import { useEffect, useRef } from 'react';
import { AppState, AppStateStatus } from 'react-native';
import { livePoller } from '@/services/livePoller';

export function useLivePoller() {
  const appState = useRef(AppState.currentState);

  useEffect(() => {
    // Inicia quando o app está em foreground
    livePoller.start();

    const sub = AppState.addEventListener('change', (nextState: AppStateStatus) => {
      if (appState.current.match(/inactive|background/) && nextState === 'active') {
        // App voltou para o foreground
        livePoller.start();
      } else if (nextState.match(/inactive|background/)) {
        // App foi para o background — pausa o poller para economizar bateria
        livePoller.stop();
      }
      appState.current = nextState;
    });

    return () => {
      sub.remove();
      livePoller.stop();
    };
  }, []);
}
